import { Plane, Vector3 } from "three";
import SceneObject from "./SceneObject";
import EditHandleData from "../sceneObjectData/EditHandleData";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";
import TextAnnotationData from "../sceneObjectData/TextAnnotationData";
import { isPlaneEdgeOn } from "../../utils/editHandleVisibility";
import PropertyList from "../properties/PropertyList";
import { PropertyId } from "../properties/PropertyId";
import PropertyItem from "../properties/PropertyItem";
import { PID_TEXT_CONTENT, PID_FONT_SIZE } from "../properties/PropertyIds";
import { CATEGORY_COMMON } from "../properties/PropertyCategoryRegistry";
import multilineStringTranslator from "../properties/translators/multilineStringTranslator";
import lengthCmTranslator from "../properties/translators/lengthCmTranslator";

export default class TextAnnotationSceneObject extends SceneObject<TextAnnotationData> {

    getProperties(props: PropertyList, filterId?: PropertyId): void {
        super.getProperties(props, filterId);

        const p = props.getOrCreateProperty(PID_TEXT_CONTENT, () => new PropertyItem(PID_TEXT_CONTENT, multilineStringTranslator));
        p.value = this.data.text;
        p.categoryId = CATEGORY_COMMON.id;

        const fontSize = props.getOrCreateProperty(PID_FONT_SIZE, () => new PropertyItem(PID_FONT_SIZE, lengthCmTranslator));
        fontSize.value = this.data.fontSize;
        fontSize.categoryId = CATEGORY_COMMON.id;
    }

    setProperties(props: PropertyList): void {
        super.setProperties(props);

        const text = props.getProperty<string>(PID_TEXT_CONTENT);
        if (text) this.data.text = text.value;

        const fontSize = props.getProperty<number>(PID_FONT_SIZE);
        if (fontSize) this.data.fontSize = fontSize.value;

        // Immediate visual refresh, same as the live in-progress updates AddChecklistItemCmd/
        // AddTextAnnotationCmd apply while dragging (forceUpdate=false).
        this.geometry.update(this.data, false);
    }

    getEditHandles(localViewDirection: Vector3): EditHandleData[] {
        const data = this.data;

        // Seen edge-on the text is unreadable and its handles collapse onto a line.
        if (isPlaneEdgeOn(localViewDirection, data.textNormal)) return [];

        const plane = new Plane().setFromNormalAndCoplanarPoint(data.textNormal, data.position);
        return [
            new EditHandleData(data.uuid, EditHandleTypeEnum.START_POINT, data.position.clone(),
                CommandIdEnum.GeometryMoveEdit,
                (d, delta) => (d as TextAnnotationData).position.add(delta),
                plane.clone()),
            new EditHandleData(data.uuid, EditHandleTypeEnum.DIMENSION_OFFSET, data.position.clone().add(data.offset),
                CommandIdEnum.GeometryMoveEdit,
                (d, delta) => (d as TextAnnotationData).offset.add(delta),
                plane.clone()),
        ];
    }
}
